import(/* webpackMode: "eager" */ "/vercel/path0/src/app/bookings/page.tsx");
